import { ncCampaignTypeConfigList } from './config';
import type { GetInternalLink } from './types';

function hasQueryParams(url: string): boolean {
  return url.includes('?');
}

export const getInternalLink: GetInternalLink = (link, type) => {
  const separator = hasQueryParams(link) ? '&' : '?';
  return `${link}${separator}utm_source=sgcm&utm_medium=website&utm_campaign=${ncCampaignTypeConfigList[type]}`; // @suppress longLineCheck
};
